module.exports = __webpack_public_path__ + "static/img/aepic-23.f68ab07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-23.jpg
// module id = sTfJ
// module chunks = 52